// extracted by mini-css-extract-plugin
export default {"suppliersLabel":"ThumbnailList_suppliersLabel__FEtRQ"};